export const getFafFormParams = fafAuthParams => {
  const fafFormParams = {};
  fafAuthParams.params.forEach(param => {
    fafFormParams[param.name] = param.value;
  });
  fafFormParams.token = fafAuthParams.access;
  fafFormParams.action = fafAuthParams.url;
  return fafFormParams;
};
